<!-- APP-设备信息 -->
<template>
  <div class="md-layout">
    <!-- 主体 -->
    <div class="md-layout-item md-size-100">
      <!-- 卡片 -->
      <md-card>
        <md-card-content>
          <!-- <div> -->
          <md-table v-model="tableData" >
            <!-- ID  账号 邮箱  手机 注册APP  登录时间 登录IP 注册时间 -->
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell :md-label="'ID'">{{ item.node_id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('dev_snid')">{{ item.dev_id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('dev_name')">{{ item.dev_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('own_user')">{{ item.share_sou }}</md-table-cell>
              <md-table-cell :md-label="$I18n('type')">{{ item.node_type_name }}</md-table-cell>

              <md-table-cell :md-label="$I18n('conn_type')">{{ item.node_type ?item.conn_mode_name :"" }}</md-table-cell>
              <md-table-cell :md-label="$I18n('vendor_id')">{{ item.vendor_id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('dev_type')">{{ item.node_type ?item.dev_type_name :""}}</md-table-cell>
              <md-table-cell :md-label="'UID/IP'">{{ !item.conn_mode ?item.ip :item.uid }}</md-table-cell>
              <md-table-cell :md-label="$I18n('dev_user')">{{ item.dev_user }}</md-table-cell>
              <md-table-cell :md-label="$I18n('channel')">{{ item.ch_no }}</md-table-cell>
              <md-table-cell :md-label="$I18n('created_thing_time')">{{ item.create_time }}</md-table-cell>
              <md-table-cell :md-label="$I18n('operate')" class="button-box">
                <md-button @click="table_delete_user_product(item)" @click.stop class="md-just-icon md-round md-danger">
                  <md-icon>close</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state">
              {{$I18n("none_data")}}
            </md-table-empty-state>
          </md-table>
          <table-page :total="total" :pageSize="pageSize" v-model="currentPage"/>
        </md-card-content>
      </md-card> 
    </div>
    <!-- 删除 -->
    <simple-modal ref="del_product" :title="$I18n('product_manage')" @submit="modal_delete">
      <template slot="body">
        <div>
          {{$I18n("check_delete", "")}}
        </div>
      </template>
    </simple-modal>
  </div>
</template>
<script>
import {timestampToString} from "@/common/tools.js";
export default {
  props:{
    user: {
      type: String
    },
    sip : {
      type: String
    },
  },
  data() {
    return {
      del_modalData_id: "",
      appList : [],
      sysList : [],
      ipList  : [],
      searchData : {
        sys : this.UserInfo.sys,
        sip : this.sip,
        share_sou: this.user,
        uid : "",
      },
      continent : {
        "AF" : this.$I18n("africa"),
        "EU" : this.$I18n("europe"),
        "AS" : this.$I18n("asia"),
        "OA" : this.$I18n("oceania"),
        "NA" : this.$I18n("north_america"),
        "SA" : this.$I18n("latin_america"),
        "AN" : this.$I18n("antarctica"),
      },
      // 表格相关
      icon  : "computer",
      title : this.$I18n("device_info"),
      tableInitData : [], // 表格数据

      // 分页相关
      pageSize : 10,
      currentPage : 1,
      total : 0,
    };
  },
  mounted : function() {
    this.api_getPageData();
  },
  watch: { 
    '$root.state':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    currentPage(){
      this.api_getPageData()
    },
  },
  computed: {
    // 表格数据
    // 表格数据
    tableData(){
      if (!this.tableInitData || this.tableInitData.length === 0){
        return [];
      } else {
        return [...this.tableInitData]
          .map(item => {
            let node_type_name = this.$I18n("unknow");
            let conn_mode_name = this.$I18n("unknow");
            let dev_type_name = this.$I18n("unknow");

            if(item.node_type == 0 || !item.node_type){
              node_type_name = this.$I18n("catalogue")
            } else if(item.node_type == 1){
              node_type_name = this.$I18n("gateway_1")
            } else if(item.node_type == 2){
              node_type_name = this.$I18n("equipment")
            }

            if(item.conn_mode == 0 || !item.conn_mode){
              conn_mode_name = this.$I18n("id_conn")
            } else if(item.conn_mode == 1){
              conn_mode_name = this.$I18n("catalogue")
            } else if(item.conn_mode == 2){
              conn_mode_name = "P2P"
            }

            if(item.dev_type == 1){
              dev_type_name = this.$I18n("home_camera")
            } else if(item.dev_type == 2){
              dev_type_name = this.$I18n("cellular_equipemnt")
            } else if(item.dev_type == 3){
              dev_type_name = this.$I18n("hard_video")
            } else if(item.dev_type == 4){
              dev_type_name = this.$I18n("out_video")
            } else if(item.dev_type == 5){
              dev_type_name = this.$I18n("low_power")
            } else if(item.dev_type == 6){
              dev_type_name = this.$I18n("low_power_video")
            }
            return {
              ...item,
              node_type_name,
              conn_mode_name,
              dev_type_name,
              create_time: item.gmt_create ?timestampToString(item.gmt_create * 1000) :"",
            }
          })
      }
    },
  },
  methods: {
    modal_delete(){
      this.$api.delAppUserProduct({
        sip : this.searchData.sip,
        node_id: this.del_modalData_id,
      })
      .then(this.$Then(() => {
        this.currentPage = 1;
        this.api_getPageData();
        this.$refs.del_product.close();
        this.$successMsg(this.$I18n("delete_success"));
      }))
      .catch(this.$Catch(this.$I18n("get_error")))
    },
    table_delete_user_product(item){
      this.del_modalData_id = item.node_id;
      this.$refs.del_product.open();
    },
    // API-表格数据
    api_getPageData(){
      this.$api.getAppUserProductList({
        ...this.searchData,
        page_size: this.pageSize,
        page_no  : this.currentPage,
      })
        .then(this.$Then(res => {
          this.tableInitData = res.data;
          this.total  = res.count
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.tableInitData = [];
          this.total  = 0;
        }))
    },
  },
}
</script>
<style lang="scss" scoped>
  .canclick:hover, .canclick.selected {
    color : #26c6da;
    cursor: pointer;
  }
  .left-btn {
    text-align:left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 表单里的单选框
  .radio-layout{
    margin-top: 6px;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  //左侧iocn
  .left-icon{
    margin-left: 16px;
  }
  // flaot 右的按钮
  .right-button {
    float:right;
  }

  .text-right .md-table-cell-container {
    display: flex;
    justify-content: flex-end;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

  .table-stats {
    display: flex;
    align-items: center;
    text-align: right;
    flex-flow: row wrap;

    .td-price .td-total {
      display: inline-flex;
      font-weight: 500;
      font-size: 1.0625rem;
      margin-right: 50px;
    }

    &.table-striped .td-price {
      border-bottom: 0;
    }

    .td-price {
      font-size: 26px;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }

    .td-price,
    > div {
      flex: 0 0 100%;
      padding: 12px 8px;
    }
  }
</style>
